// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    HasProductContext,
    ProductContextModel,
    withProductContext,
} from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import setCutProductsModalOpen from "@steiner/App/Handlers/ProductDetails/SetCutProductsModalOpen";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {}

const mapDispatchToProps = {
    setCutProductsModalOpen,
};

export interface AddCutLengthsButtonStyles {
    buttonStyles?: ButtonPresentationProps;
}

export const addCutLengthsButtonStyles: AddCutLengthsButtonStyles = {};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & HasProductContext;

const styles = addCutLengthsButtonStyles;

const AddCutLengthsButton: React.FC<Props> = ({ setCutProductsModalOpen, productContext }) => {
    const handleOpenCutProductsModal = (product: ProductContextModel) => {
        setCutProductsModalOpen({
            isOpen: true,
            product,
        });
    };

    return (
        <Button onClick={() => handleOpenCutProductsModal(productContext)} {...styles.buttonStyles}>
            {translate("Add Cut Lengths")}
        </Button>
    );
};

export default connect(null, mapDispatchToProps)(withProductContext(AddCutLengthsButton));
